'use client';

import React from 'react';
import { TasticComponentProps } from '../types';
import { Props } from './types';
import ReleaseNotesSection from '@/components/organisms/release-notes-section';

const ReleaseNotesTastic = ({ data }: TasticComponentProps<Props>) => {
  return (
    <>
      <ReleaseNotesSection data={data?.data?.dataSource} />
    </>
  )
};

export default ReleaseNotesTastic;
